import { Component, Input, OnInit } from '@angular/core';
import { BaseComponentDirective } from '@core/component/base.component';
import { CallLogViewModel } from '@app/shared/models/call-log-model';
import { CalllogService } from '@app/shared/services/call-log-service';
import { takeUntil } from 'rxjs';

@Component({
    selector: 'app-lead-call-history',
    templateUrl: './lead-call-history.component.html',
    styleUrls: ['./lead-call-history.component.scss'],
})
export class LeadCallHistoryComponent extends BaseComponentDirective implements OnInit {
    @Input() leadId: string;
    selectedUsers: CallLogViewModel;
    callLogs: CallLogViewModel[];
    loading = false;

    constructor(private readonly calllogService: CalllogService) {
        super();
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.getCallLogsList();
    }

    getCallLogsList() {
        this.loading = true;
        this.calllogService.getCallLog(this.leadId).pipe(takeUntil(this.onDestroy$)).subscribe({
            next: (res) => {
                this.callLogs = res;
                this.loading = false;
            },
            error: (_error) => {
                this.loading = false;
            },
        });
    }
}
